var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-12"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }